import R, { useState as F, useRef as A, useCallback as W, useEffect as h, useContext as N, useMemo as L } from "react";
import { jsx as g, jsxs as w } from "react/jsx-runtime";
import { useFoundation as x, matches as B, emptyClientRect as S, Tag as I, createComponent as y, useClassNames as O, classNames as k, useId as M } from "@rmwc/base";
import { MDCTabScrollerFoundation as E, util as K } from "@material/tab-scroller";
import { MDCTabBarFoundation as _ } from "@material/tab-bar";
import { Icon as D } from "@rmwc/icon";
import { MDCFadingTabIndicatorFoundation as q, MDCSlidingTabIndicatorFoundation as H } from "@material/tab-indicator";
import { withRipple as V, RippleSurface as j } from "@rmwc/ripple";
import { MDCTabFoundation as z } from "@material/tab";
const P = R.createContext({
  onTabInteraction: (o) => {
  },
  registerTab: (o) => {
  },
  unregisterTab: (o) => {
  },
  indicatorTransition: "slide"
}), X = (o) => {
  const { foundation: i, ...m } = x({
    props: o,
    api: ({ foundation: l, contentEl: f }) => {
      const u = l;
      return {
        scrollTo: (t) => u.scrollTo(t),
        incrementScroll: (t) => u.incrementScroll(t),
        getScrollPosition: () => u.getScrollPosition(),
        getScrollContentWidth: () => {
          var t;
          return ((t = f.ref) == null ? void 0 : t.offsetWidth) || 0;
        }
      };
    },
    elements: { rootEl: !0, areaEl: !0, contentEl: !0 },
    foundation: ({ rootEl: l, areaEl: f, contentEl: u }) => new E({
      eventTargetMatchesSelector: (t, T) => B(t, T),
      addClass: (t) => l.addClass(t),
      removeClass: (t) => l.removeClass(t),
      addScrollAreaClass: (t) => f.addClass(t),
      setScrollAreaStyleProperty: (t, T) => f.setStyle(t, T),
      setScrollContentStyleProperty: (t, T) => u.setStyle(t, T),
      getScrollContentStyleValue: (t) => u.ref && window.getComputedStyle(u.ref).getPropertyValue(t) || "none",
      setScrollAreaScrollLeft: (t) => f.ref && (f.ref.scrollLeft = t),
      getScrollAreaScrollLeft: () => f.ref ? f.ref.scrollLeft : 0,
      getScrollContentOffsetWidth: () => u.ref ? u.ref.offsetWidth : 0,
      getScrollAreaOffsetWidth: () => f.ref ? f.ref.offsetWidth : 0,
      computeScrollAreaClientRect: () => f.ref ? f.ref.getBoundingClientRect() : S,
      computeScrollContentClientRect: () => u.ref ? u.ref.getBoundingClientRect() : S,
      computeHorizontalScrollbarHeight: () => K.computeHorizontalScrollbarHeight(document)
    })
  }), { areaEl: c, contentEl: d } = m, n = () => {
    i.handleInteraction();
  }, s = (l) => {
    i.handleTransitionEnd(l);
  };
  return c.setProp("onWheel", n, !0), c.setProp("onTouchStart", n, !0), c.setProp("onPointerDown", n, !0), c.setProp("onMouseDown", n, !0), c.setProp("onKeyDown", n, !0), d.setProp("onTransitionEnd", s, !0), { ...m };
};
function Y(o) {
  const { children: i, apiRef: m, ...c } = o, { rootEl: d, areaEl: n, contentEl: s } = X(o);
  return /* @__PURE__ */ g(I, { ...c, ref: null, element: d, className: "mdc-tab-scroller", children: /* @__PURE__ */ g(I, { element: n, className: "mdc-tab-scroller__scroll-area", children: /* @__PURE__ */ g(I, { element: s, className: "mdc-tab-scroller__scroll-content", children: i }) }) });
}
const $ = (o) => {
  const [i, m] = F(
    o.activeTabIndex || 0
  ), c = A(), d = (a) => c.current = a, n = A([]), { foundation: s, ...l } = x({
    props: o,
    elements: { rootEl: !0 },
    foundation: ({ rootEl: a, emit: e, getProps: b }) => new _({
      scrollTo: (r) => {
        c.current && c.current.scrollTo(r);
      },
      incrementScroll: (r) => {
        var v;
        (v = c.current) == null || v.incrementScroll(r);
      },
      getScrollPosition: () => {
        var r;
        return ((r = c.current) == null ? void 0 : r.getScrollPosition()) || 0;
      },
      getScrollContentWidth: () => {
        var r;
        return ((r = c.current) == null ? void 0 : r.getScrollContentWidth()) || 0;
      },
      getOffsetWidth: () => a.ref ? a.ref.offsetWidth : 0,
      isRTL: () => !!a.ref && window.getComputedStyle(a.ref).getPropertyValue("direction") === "rtl",
      setActiveTab: (r) => {
        o.activeTabIndex === r || o.activeTabIndex === void 0 ? m(r) : s.adapter.notifyTabActivated(r);
      },
      activateTabAtIndex: (r, v) => {
        n.current[r] && n.current[r].activate(v);
      },
      deactivateTabAtIndex: (r) => n.current[r] && n.current[r].deactivate(),
      focusTabAtIndex: (r) => n.current[r].focus(),
      getTabIndicatorClientRectAtIndex: (r) => n.current[r] && n.current[r].computeIndicatorClientRect(),
      getTabDimensionsAtIndex: (r) => n.current[r] && n.current[r].computeDimensions(),
      getPreviousActiveTabIndex: () => {
        for (let r = 0; r < n.current.length; r++)
          if (n.current[r].getActive())
            return r;
        return -1;
      },
      getFocusedTabIndex: () => {
        var p;
        const r = [].slice.call(
          (p = a.ref) == null ? void 0 : p.querySelectorAll(
            _.strings.TAB_SELECTOR
          )
        ), v = document.activeElement;
        return r ? r.indexOf(v) : -1;
      },
      getIndexOfTabById: (r) => {
        for (let v = 0; v < n.current.length; v++)
          if (n.current[v].id === r)
            return v;
        return -1;
      },
      getTabListLength: () => n.current.length,
      notifyTabActivated: (r) => e("onActivate", { index: r }, !0)
    })
  }), { rootEl: f } = l, u = (a) => {
    n.current.push(a), n.current.sort((e, b) => e.getIndex() - b.getIndex());
  }, t = (a) => {
    n.current.splice(n.current.indexOf(a), 1), n.current.sort((e, b) => e.getIndex() - b.getIndex());
  }, T = W(
    (a) => {
      s.handleTabInteraction(a);
    },
    [s]
  ), C = (a) => {
    var e;
    (e = o.onKeyDown) == null || e.call(o, a), s.handleKeyDown(a);
  };
  return f.setProp("onKeyDown", C, !0), h(() => {
    o.activeTabIndex !== void 0 && m(o.activeTabIndex);
  }, [o.activeTabIndex]), h(() => {
    const a = i, e = s.adapter, b = e.getPreviousActiveTabIndex();
    if (!(!s.indexIsInRange(a) || a === b))
      return e.notifyTabActivated(a), window.requestAnimationFrame(() => {
        e.activateTabAtIndex(
          a,
          e.getTabIndicatorClientRectAtIndex(b)
        ), s.scrollIntoView(a);
      }), () => {
        window.requestAnimationFrame(() => {
          e.deactivateTabAtIndex(a);
        });
      };
  }, [i, s]), h(() => {
    const a = window.document.activeElement, [e, b] = [window.scrollX, window.scrollY];
    window.requestAnimationFrame(() => {
      a && a.focus(), window.scrollTo(e, b);
    });
  }, []), {
    ...l,
    setTabScrollerApi: d,
    handleTabInteraction: T,
    registerTab: u,
    unregisterTab: t
  };
}, lt = y(function(i, m) {
  const { children: c, activeTabIndex: d, onActivate: n, foundationRef: s, ...l } = i, {
    rootEl: f,
    handleTabInteraction: u,
    setTabScrollerApi: t,
    registerTab: T,
    unregisterTab: C
  } = $(i), a = A({
    onTabInteraction: (b) => u(b),
    registerTab: T,
    unregisterTab: C,
    indicatorTransition: i.indicatorTransition || "slide"
  }), e = O(i, ["mdc-tab-bar"]);
  return /* @__PURE__ */ g(P.Provider, { value: a.current, children: /* @__PURE__ */ g(
    I,
    {
      tag: "div",
      role: "tablist",
      element: f,
      ...l,
      className: e,
      ref: m,
      children: /* @__PURE__ */ g(Y, { apiRef: t, children: c })
    }
  ) });
}), G = (o) => {
  const { foundation: i, ...m } = x({
    props: o,
    elements: { rootEl: !0, contentEl: !0 },
    foundation: ({ rootEl: c, contentEl: d }) => {
      const n = {
        addClass: (s) => {
          c.addClass(s);
        },
        removeClass: (s) => {
          c.removeClass(s);
        },
        computeContentClientRect: () => d.ref ? d.ref.getBoundingClientRect() : S,
        setContentStyleProperty: (s, l) => {
          d.setStyle(s, l);
        }
      };
      return o.transition === "fade" ? new q(n) : new H(n);
    },
    api: ({
      foundation: c
    }) => ({
      activate: (d) => {
        c.activate(d);
      },
      deactivate: () => {
        c.deactivate();
      },
      computeContentClientRect: () => c.computeContentClientRect()
    })
  });
  return { ...m };
};
function J(o) {
  const { rootEl: i, contentEl: m } = G(o), { icon: c, transition: d } = o;
  return /* @__PURE__ */ g(
    I,
    {
      tag: "span",
      element: i,
      className: k("mdc-tab-indicator", {
        "mdc-tab-indicator--fade": d === "fade"
      }),
      children: /* @__PURE__ */ g(
        I,
        {
          tag: c ? D : "span",
          "aria-hidden": "true",
          icon: c,
          element: m,
          className: `mdc-tab-indicator__content mdc-tab-indicator__content--${c ? "icon" : "underline"}`
        }
      )
    }
  );
}
const Q = (o) => {
  const i = A(), m = (t) => i.current = t, c = N(P), d = M("tab", o), { foundation: n, ...s } = x({
    props: o,
    elements: { rootEl: !0, contentEl: !0 },
    foundation: ({ rootEl: t, contentEl: T, emit: C, getProps: a }) => new z(
      /** @type {!MDCTabAdapter} */
      {
        setAttr: (e, b) => t.setProp(e, b),
        addClass: (e) => t.addClass(e),
        removeClass: (e) => t.removeClass(e),
        hasClass: (e) => t.hasClass(e),
        activateIndicator: (e) => {
          var b;
          return (b = i.current) == null ? void 0 : b.activate(e);
        },
        deactivateIndicator: () => {
          var e;
          return (e = i.current) == null ? void 0 : e.deactivate();
        },
        notifyInteracted: () => {
          const e = C(
            "onInteraction",
            { tabId: d },
            !0
            /* bubble */
          );
          c.onTabInteraction(e);
        },
        getOffsetLeft: () => {
          var e;
          return ((e = t.ref) == null ? void 0 : e.offsetLeft) || 0;
        },
        getOffsetWidth: () => {
          var e;
          return ((e = t.ref) == null ? void 0 : e.offsetWidth) || 0;
        },
        getContentOffsetLeft: () => {
          var e;
          return ((e = T.ref) == null ? void 0 : e.offsetLeft) || 0;
        },
        getContentOffsetWidth: () => {
          var e;
          return ((e = T.ref) == null ? void 0 : e.offsetWidth) || 0;
        },
        focus: () => t.ref && t.ref.focus && t.ref.focus()
      }
    )
  }), { rootEl: l } = s, f = (t) => {
    var T;
    (T = o.onClick) == null || T.call(o, t), n.handleClick();
  };
  l.setProp("onClick", f, !0);
  const u = L(() => ({
    getActive: () => n.isActive(),
    activate: (t) => n.activate(t),
    deactivate: () => n.deactivate(),
    computeIndicatorClientRect: () => {
      var t;
      return ((t = i.current) == null ? void 0 : t.computeContentClientRect()) || S;
    },
    computeDimensions: () => n.computeDimensions(),
    focus: () => l.ref && l.ref.focus(),
    id: d,
    getIndex: () => {
      var t;
      return (t = l.ref) != null && t.parentElement ? Array.from(l.ref.parentElement.children).indexOf(l.ref) : -1;
    }
  }), [n, l.ref, d]);
  return h(() => (c.registerTab(u), () => {
    c.unregisterTab(u);
  }), [c, u]), h(() => {
    o.focusOnActivate !== void 0 && n.setFocusOnActivate(o.focusOnActivate);
  }, [n, o.focusOnActivate]), {
    ...s,
    setTabIndicatorApi: m
  };
}, U = V({ surface: !1 })(
  y(function(i, m) {
    const { stacked: c, minWidth: d, ...n } = i, s = O(i, [
      "mdc-tab",
      {
        "mdc-tab--stacked": c,
        "mdc-tab--min-width": d
      }
    ]);
    return /* @__PURE__ */ g(I, { tag: "button", role: "tab", ...n, className: s, ref: m });
  })
), Z = R.memo(function(i) {
  return /* @__PURE__ */ g(D, { ...i, className: "mdc-tab__icon" });
}), dt = y(function(i, m) {
  const {
    children: c,
    label: d,
    icon: n,
    stacked: s,
    restrictIndicator: l,
    onInteraction: f,
    iconIndicator: u,
    foundationRef: t,
    focusOnActivate: T,
    ...C
  } = i, { rootEl: a, contentEl: e, setTabIndicatorApi: b } = Q(i), r = R.useContext(P), v = /* @__PURE__ */ g(
    J,
    {
      apiRef: b,
      transition: r.indicatorTransition,
      icon: u
    }
  );
  return /* @__PURE__ */ w(U, { element: a, stacked: s, ...C, ref: m, children: [
    /* @__PURE__ */ w(
      "div",
      {
        className: "mdc-tab__content",
        ref: e.reactRef,
        children: [
          !!n && /* @__PURE__ */ g(Z, { icon: n }),
          (c !== void 0 || d !== void 0) && /* @__PURE__ */ w("span", { className: "mdc-tab__text-label", children: [
            d,
            c
          ] }),
          !!l && v
        ]
      }
    ),
    !l && v,
    /* @__PURE__ */ g(j, { className: "mdc-tab__ripple" }),
    /* @__PURE__ */ g("div", { className: "mdc-tab__focus-ring" })
  ] });
});
export {
  dt as Tab,
  lt as TabBar,
  P as TabBarContext,
  J as TabIndicator,
  Y as TabScroller
};
